import { MssDataPoint } from '@repo/types';
import { useSuspenseQuery } from '@tanstack/react-query';
import { API } from 'api';
import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { apiName, apiBasePath } from 'assets';

export type MssDataResponse = {
  mssData: MssDataPoint[];
  popGutScore: string | null;
};

export const getMssData = async (kitId: string): Promise<MssDataResponse> => {
  const response = await API.get(
    apiName,
    `${apiBasePath}/results/mss-data/${kitId}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.MSS,
        importance: IMPORTANCE.HIGH,
      },
      context: {
        kitId,
      },
    },
  );
  return response.result;
};

export const getMssDataQuery = (kitId?: string | null) => ({
  queryKey: [apiName, 'mssData', kitId],
  queryFn: () => (kitId ? getMssData(kitId) : null),
});

export const useMssData = (kitId?: string | null) => {
  const mssDataQuery = useSuspenseQuery(getMssDataQuery(kitId));
  return {
    ...mssDataQuery,
    mssData: mssDataQuery.data?.mssData || [],
    popGutScore: Number(mssDataQuery.data?.popGutScore) || null,
  };
};

export default useMssData;
